export const SHOP_BULK_UPLOAD_KEYS = {
    ["brands"]: { value: "brands", text: "브랜드" },
    ["categories"]: { value: "categories", text: "카테고리" },
    ["products"]: { value: "products", text: "상품" },
    ["options"]: { value: "options", text: "필수옵션" },
    ["choicees"]: { value: "choicees", text: "필수옵션(연동)" },
    ["relateds"]: { value: "relateds", text: "추가옵션(연동)" },
    ["bundleds"]: { value: "bundleds", text: "세트상품" },
};
